import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { AvatarApi } from "services/avatar";
import format from "date-fns/format";
import isValid from "date-fns/isValid";

const CommentStyle = styled.div`
  display: flex;
  height: 60px;
  margin-bottom: 10px;
  &.expand {
    height: 100px;
    .details {
      .detail-box {
        .detail-text {
          .comment-value {
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .character-count-text {
            cursor: pointer;
            display: none;
            &.less {
              display: inline;
            }
          }
        }
      }
    }
  }
  .avatar {
    display: flex;
    justify-content: flex-end;
    min-width: 35px;
    padding-left: 5px;
    padding-right: 5px;
    img {
      width: 35px;
      height: 35px;
      border-radius: 20px;
    }
  }
  .details {
    width: 100%;

    .detail-box {
      padding: 5px;
      background-color: ${(props) => props.theme.white};
      width: 100%;
      height: 100%;

      .detail-header {
        display: flex;
        .user {
          color: ${(props) => props.theme.support};
          .dot {
            margin-right: 5px;
            margin-left: 5px;
          }
        }
      }
      .detail-text {
        margin-top: 5px;
        .comment-value {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .character-count-text {
          margin-top: 5px;
          cursor: pointer;
          &.less {
            display: none;
          }
        }
      }
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    display: flex;
    height: 80px;
    margin-bottom: 15px;
    &.expand {
      height: 100px;
      .details {
        .detail-box {
          .detail-text {
            .comment-value {
              -webkit-line-clamp: 5;
            }
          }
        }
      }
    }
    .avatar {
      min-width: 40px;
      padding-left: 10px;
      padding-right: 10px;
      img {
        width: 40px;
        height: 40px;
      }
    }
    .details {
      .detail-box {
        padding: 10px;
        .detail-header {
          .user {
            .dot {
              margin-right: 5px;
              margin-left: 5px;
            }
          }
        }
        .detail-text {
          margin-top: 5px;
          .comment-value {
            -webkit-line-clamp: 3;
          }
          .character-count-text {
            margin-top: 5px;
            cursor: pointer;
          }
        }
      }
    }
    .ScrollbarsCustom-Track {
      right: -12px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.support} !important;
      width: 8px !important;
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    height: 100px;
    margin-bottom: 15px;
    &.expand {
      height: 120px;
      .details {
        .detail-box {
          .detail-text {
            .comment-value {
              -webkit-line-clamp: 5;
            }
          }
        }
      }
    }
    .avatar {
      min-width: 50px;
      padding-left: 15px;
      padding-right: 15px;
      img {
        width: 50px;
        height: 50px;
      }
    }
    .details {
      .detail-box {
        padding: 15px;
        .detail-header {
          .user {
            .dot {
              margin-right: 5px;
              margin-left: 5px;
            }
          }
        }
        .detail-text {
          margin-top: 10px;
          .comment-value {
            -webkit-line-clamp: 4;
          }
          .character-count-text {
            margin-top: 5px;
            cursor: pointer;
          }
        }
      }
    }
    .ScrollbarsCustom-Track {
      right: -10px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.storage} !important;
      width: 10px !important;
    }
  }
`;

function getFormattedMonth(date) {
  const formattedDate = new Date(date);

  if (isValid(formattedDate)) {
    return format(formattedDate, "MM-dd-yyyy HH:mm");
  } else {
    return " -- ";
  }
}

function checkCommentLength(comment) {
  if (comment?.length >= 200) {
    return true;
  } else {
    return false;
  }
}

function setLength(index) {
  const comment = document.getElementById(index);
  if (comment) {
    comment.classList.add("expand");
  }
}
function removeLength(index) {
  const comment = document.getElementById(index);

  if (comment) {
    comment.classList.remove("expand");
  }
}

export const Comment = ({ comment, index }) => {
  const [userName, setUserName] = useState([]);
  const [avatar, setUserAvatar] = useState([]);
  const [displayComment, setDisplayComment] = useState("");
  const avatarApi = new AvatarApi();

  useEffect(() => {
    function getUserData() {
      if (comment?.body && comment.body.includes("Commented By:")) {
        const commentParts = comment.body.split("Commented By:");
        if (commentParts.length > 1) {
          const extractedName = commentParts[1].trim();
          const img = avatarApi.getGenericAvatar();
          setUserAvatar(img);
          setUserName(extractedName);
          setDisplayComment(commentParts[0].trim());
        }
      } else {
        setUserName(comment?.author?.displayName);
        setUserAvatar(avatarApi.getGenericAvatar());
        setDisplayComment(comment?.body);
      }
    }
    getUserData();
  }, []);

  const viewMore = checkCommentLength(displayComment);

  return (
    <CommentStyle className="comment" id={`comment-${index}`}>
      {avatar && (
        <div className="avatar">
          {" "}
          <img alt="" src={avatar} />
        </div>
      )}
      <div className="details">
        <div className={`detail-box`}>
          <div className="detail-header buttons11">
            <div className="user">
              {userName}
              <span className="dot">.</span>
            </div>

            <div className="timestamp">
              <span>{getFormattedMonth(comment?.created)}</span>
            </div>
          </div>
          <div className={`detail-text numbers5`}>
            <span className="comment-value">{displayComment} </span>
            {viewMore && (
              <span
                className="character-count-text"
                onClick={() => setLength(`comment-${index}`)}
              >
                More
              </span>
            )}
            <span
              className="character-count-text less"
              onClick={() => removeLength(`comment-${index}`)}
            >
              Less
            </span>
          </div>
          {/* <div className='detail-attachments'>
						Attachments:{' '}
						{/* <span className='attachment-amount'>({attachments ? attachments : 0})</span> */}
          {/* </div>  */}
        </div>
      </div>
    </CommentStyle>
  );
};
// LargeInfoDisplay.propTypes = {
// 	type: string.isRequired,
// };

// LargeInfoDisplay.defaultProps = {};
